export enum ProfileTab {
  'Employee' = 0
}
